<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption"
                       :data="tableData"
                       :table-loading="tableLoading"
                       :page="page"
                       ref="crud"
                       @search-change="searchChange"
                       @refresh-change="refreshChange"
                       @row-save="handleSave"
                       @row-update="handleUpdate"
                       @selection-change="handleSelectionChange"
                       @size-change="pageSizeChange"
                       @current-change="pageChange">

                <template slot-scope="scope" slot="menuLeft">
                    <el-button type="primary"
                               icon="el-icon-plus"
                               size="small"
                               plain
                               @click.stop="handleAdd()"
                    >新增</el-button>
                    <el-button type="danger"
                               icon="el-icon-check"
                               size="small"
                               plain
                               @click.stop="handleDel">物理删除</el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button type="primary"
                               icon="el-icon-check"
                               size="small"
                               plain
                               @click.stop="handleEdit(scope.row,scope.index)"
                    >编辑</el-button>
                    <el-button type="primary"
                               icon="el-icon-check"
                               size="small"
                               v-if="scope.row.status=='STOP'"
                               plain
                               @click.stop="startRule(scope.row.id)"
                    >启用</el-button>
                    <el-button type="danger"
                               icon="el-icon-check"
                               size="small"
                               v-if="scope.row.status=='START'"
                               plain
                               @click.stop="stopRule(scope.row.id)">停用</el-button>
                </template>
                <template slot-scope="scope" slot="status">
                    <el-tag v-for="obj of status" :key="obj.value" v-if="obj.value == scope.row.status">
                        {{obj.label}}
                    </el-tag>
                </template>
            </avue-crud>
        </basic-container>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import {ruleOption} from "@/const/salesCloud/ruleOption";
    import {findRuleList,addRule,editRule,delRule,startRule,stopRule} from "@/api/salesCloud/rule"
    import { findByLabel } from "@/util/util"
    import { DIC } from "@/const/dic"
    export default {
        name: "rule",
        components: {},
        data () {
            return {
                tableOption: ruleOption, //表格设置属性
                tableData: [], //表格的数据
                tablePage: 1,
                tableLoading: false,
                tabelObj: {},
                page: {
                    total: 0, //总页数
                    currentPage: 1, //当前页数
                    pageSize: 10 //每页显示多少条
                },
                grade: {
                    box: false,
                    check: []
                },
                status:DIC.EXIT_RULE_STATUS
            };
        },
        created () {
            this.handleList();
        },
        watch: {},
        mounted () { },
        computed: {
            ...mapGetters(["permission"])
        },
        props: [],
        methods: {
            pageSizeChange(pageSize){
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage,
                    params.size = pageSize
                findRuleList(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: pageSize
                    };
                    this.tableLoading = false;
                })
            },
            pageChange(page){
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page
                params.size = this.page.pageSize
                findRuleList(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            searchChange(params){
                this.tableLoading = true;
                // let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage
                params.size = this.page.pageSize
                findRuleList(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                })
            },
            refreshChange(page){
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page.currentPage
                params.size = page.pageSize
                findRuleList(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page.currentPage,
                        pageSize: page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            /**
             * @title 打开新增窗口
             * @detail 调用crud的handleadd方法即可
             *
             **/
            handleAdd () {
                this.$refs.crud.rowAdd();
            },
            handleEdit (row, index) {
                this.$refs.crud.rowEdit(row, index);
            },
            /**
             * @title 获取数据
             * @detail 赋值为tableData表格即可
             *
             **/
            handleList () {
                this.tableLoading = true;
                let parmas = {
                    page: this.page.currentPage,
                    size: this.page.pageSize
                }
                findRuleList(parmas).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            /**
             * @title 数据添加
             * @param row 为当前的数据
             * @param done 为表单关闭函数
             *
             **/
            handleSave (row, done) {
                addRule(row).then(response => {
                    if(response.code == '200'){
                        this.$message({
                            showClose: true,
                            message: "添加成功",
                            type: "success"
                        });
                        this.handleList();
                    }else{
                        this.$message({
                            showClose: true,
                            message: response.message,
                            type: "error"
                        })
                    }

                }).catch(error => {
                    this.loading = false
                    this.$message({
                        showClose: true,
                        message: error,
                        type: "error"
                    })
                })
                done();
            },
            /**
             * @title 当前选中的数据
             * @param val 选中的值
             *
             **/
            handleSelectionChange () {
                // console.log(val);
                // this.tableRow = val;
                // this.$notify({
                //     showClose: true,
                //     message: JSON.stringify(val),
                //     type: 'success',
                // });
            },
            /**
             * @title 数据删除
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             *
             **/
            handleDel () {
                if(this.$refs.crud.tableSelect.length == 0){
                    this.$message({
                        showClose: true,
                        message: "请选择要操作的数据",
                        type: "error"
                    })
                    return
                }

                this.$confirm(`是否确认删除?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        let ids = new Array();
                        for(let row of this.$refs.crud.tableSelect){
                            ids.push(row.id)
                        }

                        delRule(ids).then(response => {
                            if(response.code == '200'){
                                this.$message({
                                    showClose: true,
                                    message: "删除成功",
                                    type: "success"
                                });
                                this.handleList();
                            }else{
                                this.$message({
                                    showClose: true,
                                    message: response.message,
                                    type: "error"
                                })
                            }

                        }).catch(error => {
                            this.loading = false
                            this.$message({
                                showClose: true,
                                message: error,
                                type: "error"
                            })
                        })
                    })
                    .catch(() => { });

            },
            /**
             * @title 数据更新
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             * @param done 为表单关闭函数
             *
             **/
            handleUpdate (row, index, done) {
                editRule(row).then(response => {
                    if(response.code == '200'){
                        this.$message({
                            showClose: true,
                            message: "添加成功",
                            type: "success"
                        });
                        this.handleList();
                    }else{
                        this.$message({
                            showClose: true,
                            message: response.message,
                            type: "error"
                        })
                    }

                }).catch(error => {
                    this.loading = false
                    this.$message({
                        showClose: true,
                        message: error,
                        type: "error"
                    })
                })
                done();
            },
            startRule(id){
                startRule(id).then(response => {
                    if(response.code == '200'){
                        this.$message({
                            showClose: true,
                            message: "启用成功",
                            type: "success"
                        });
                        this.handleList();
                    }else{
                        this.$message({
                            showClose: true,
                            message: response.message,
                            type: "error"
                        })
                    }

                }).catch(error => {
                    this.loading = false
                    this.$message({
                        showClose: true,
                        message: error,
                        type: "error"
                    })
                })
                done();
            },
            stopRule(id){
                stopRule(id).then(response => {
                    if(response.code == '200'){
                        this.$message({
                            showClose: true,
                            message: "停用成功",
                            type: "success"
                        });
                        this.handleList();
                    }else{
                        this.$message({
                            showClose: true,
                            message: response.message,
                            type: "error"
                        })
                    }

                }).catch(error => {
                    this.loading = false
                    this.$message({
                        showClose: true,
                        message: error,
                        type: "error"
                    })
                })
                done();
            }
        }
    };
</script>

<style lang="scss">
    .table-container {
        padding: 8px 10px;
    }
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>
